import React, { useMemo } from 'react';

function formatNumberWithCommas(value) {
  if (value === null || value === undefined || value === '') return '0';
  const num = Number(String(value).replace(/,/g, ''));
  if (!Number.isFinite(num)) return String(value);
  return num.toLocaleString('ko-KR');
}

/** TRP_S_주문조회_주문정보 응답 기준 금액 파생 */
export function deriveOtherCompanyOrderAmounts(orderInfo) {
  const productAmount = Number(orderInfo?.고객결제가) || 0;
  const totalSalesPrice = Number(orderInfo?.대리점결제가) || 0;
  const depositedAmount = Number(orderInfo?.결제금액) || 0;
  const agencyCommission = Math.max(0, productAmount - totalSalesPrice);
  const receivable =
    orderInfo?.미수금 != null && orderInfo?.미수금 !== ''
      ? Number(orderInfo.미수금) || 0
      : Math.max(0, productAmount - depositedAmount);

  return {
    totalSalesPrice,
    productAmount,
    agencyCommission,
    depositedAmount,
    receivable,
  };
}

export default function OtherCompanyOrderPricePanel({ orderInfo, loading, error }) {
  const amounts = useMemo(
    () => (orderInfo ? deriveOtherCompanyOrderAmounts(orderInfo) : null),
    [orderInfo]
  );

  if (loading) {
    return <div className="px-4 py-8 text-sm text-gray-500">주문 금액 정보를 불러오는 중...</div>;
  }

  if (error) {
    return <div className="px-4 py-6 text-sm text-red-600">{error}</div>;
  }

  if (!amounts) {
    return <div className="px-4 py-6 text-sm text-gray-500">주문 금액 정보가 없습니다.</div>;
  }

  const {
    totalSalesPrice,
    productAmount,
    agencyCommission,
    depositedAmount,
    receivable,
  } = amounts;

  return (
    <div className="space-y-0 border border-gray-200 rounded-xl overflow-hidden bg-white">
      <div className="px-4 pb-4 pt-4 border-b border-gray-200">
        <div className="text-base font-semibold text-gray-800 flex items-center gap-2">
          <span className="inline-block w-1 h-4 bg-blue-600 rounded-sm" />
          총 판매가
        </div>
        <div className="ml-3 text-2xl font-semibold text-gray-900 tabular-nums mt-1">
          {formatNumberWithCommas(totalSalesPrice)}
        </div>
        <div className="ml-3 mt-2 text-[13px] text-gray-700 flex items-center gap-2 flex-wrap">
          <span className="flex items-center gap-1">
            <span className="text-gray-500">상품금액</span>
            <span className="tabular-nums font-semibold">{formatNumberWithCommas(productAmount)}</span>
          </span>
          {agencyCommission > 0 && (
            <>
              <span className="text-gray-400">-</span>
              <span className="flex items-center gap-1">
                <span className="text-gray-500">대리점커미션</span>
                <span className="tabular-nums font-semibold text-blue-700">
                  {formatNumberWithCommas(agencyCommission)}
                </span>
              </span>
            </>
          )}
        </div>
      </div>

      <div className="px-4 py-4 border-b border-gray-200">
        <div className="text-base font-semibold text-gray-800 flex items-center gap-2">
          <span className="inline-block w-1 h-4 bg-blue-600 rounded-sm" />
          입금된 금액
        </div>
        <div className="ml-3 text-2xl font-semibold text-gray-900 tabular-nums mt-1">
          {formatNumberWithCommas(depositedAmount)}
        </div>
      </div>

      <div className="px-4 py-4">
        <div className="text-base font-semibold text-gray-800 flex items-center gap-2">
          <span className="inline-block w-1 h-4 bg-blue-600 rounded-sm" />
          미수금
        </div>
        <div className="ml-3 text-2xl font-semibold text-gray-900 tabular-nums mt-1">
          {receivable === 0 ? (
            <span className="text-green-600">완납</span>
          ) : (
            formatNumberWithCommas(receivable)
          )}
        </div>
        {receivable !== 0 && (
          <div className="ml-3 mt-2 text-[13px] text-gray-500">
            주문정보 기준 미수금
          </div>
        )}
      </div>
    </div>
  );
}
